import { ReactElement } from 'react';

import { CardDataSchema, Directions } from '@cashier/cashier-model';
import { useUIConfiguration } from '@cashier/cashier-shared';
import { cn } from '@cashier/cashier-ui';

import { useCashierConfiguration } from '../../hooks';
import { DateField } from './modules/dateField';
import { StandardField } from './modules/standardField';

import styles from './styles.module.scss';

interface CardDataProps {
  schema: CardDataSchema;
  version: 'v2' | 'v3';
}

export const StandardCardData = ({
  schema,
  version,
}: CardDataProps): ReactElement => {
  const { direction } = useCashierConfiguration();

  const hasBothExpiryAndCvv = !!schema.expirationDate && !!schema.cvv;

  const inputLabel = useUIConfiguration('input', 'label');
  const isInputWithInlineLabelPosition =
    inputLabel === 'inline' || (inputLabel === 'default' && version === 'v3');

  return (
    <>
      {schema.cardHolder && (
        <div className={cn([styles.row])}>
          <div className={styles.fieldFull}>
            <div className={cn([styles.col, styles.full])}>
              <StandardField field={schema.cardHolder} version={version} />
            </div>
          </div>
        </div>
      )}
      {schema.cardNumber && (
        <div className={cn([styles.row])}>
          <div className={styles.fieldFull}>
            <div className={cn([styles.col, styles.full])}>
              <StandardField field={schema.cardNumber} version={version} />
            </div>
          </div>
        </div>
      )}
      {(schema.expirationDate || schema.cvv) && (
        <div className={cn([styles.row])}>
          {schema.expirationDate && (
            <div
              className={cn({
                [styles.fieldHalf]: hasBothExpiryAndCvv,
                [styles.fieldFull]: !hasBothExpiryAndCvv,
                [styles.paddingRight]: hasBothExpiryAndCvv,
                [styles.rtl]: direction === Directions.Rtl,
              })}
            >
              <DateField field={schema.expirationDate} />
            </div>
          )}

          {schema.cvv && (
            <div
              className={cn({
                [styles.fieldHalf]: hasBothExpiryAndCvv,
                [styles.fieldFull]: !hasBothExpiryAndCvv,
              })}
            >
              <div
                className={cn({
                  [styles.col]: true,
                  [schema.expirationDate ? styles.halfWidth : styles.fullWidth]:
                    true,
                  [styles.flexColumn]: isInputWithInlineLabelPosition,
                })}
              >
                <StandardField field={schema.cvv} version={version} />
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};
